// Videos JWT 
// https://youtu.be/nI8PYZNFtac
import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { ApiCallPost} from "../ApiCall/ApiCall"
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

import { useNavigate  } from "react-router-dom";

// Importación de los estilos
import "./LogIn.css"
//import { getPickersArrowSwitcherUtilityClass } from "@mui/x-date-pickers/internals/components/PickersArrowSwitcher/pickersArrowSwitcherClasses";



export default function Login( ) {

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    clearErrors,
    control,
    formState: {
      errors
    }
  } = useForm();


  function onCrearCuenta() {

    navigate("/signup" , { state : { clave : "supertools"} }); // Deberia llevar parametros

  }

  const onSubmit = async (data) => {
    console.log(data);

    //console.log( "Validation = " , data.validation )

    if (data.mail !== "" && data.password !== "" ) {
      console.log("Me voy a loguear")

      // data.user = data.mail;
      // data.password = data.password;
      // data.last_login = new Date();

      var obj = {
        "user": data.mail,
        "password": data.password,
        "dTimeStamp": new Date()
      }


      console.log( "Antes del post = " , obj )


      //return ;

      try {
        ApiCallPost("login", data)
        .then( response =>{

          console.log( "Response = ", response )

          if ( response.length === 0 )
          {
            alert("El usuario o clave son incorrectos")
            return ; 
          }

          navigate( '/loadexcel')

          
          return ;

        })
        .catch( err =>{
          console.log( err ) 

          alert( "El usuario o clave son incorrectos")

        })
      }
      catch (error) {
        console.log("Error en la llamada: ", error);
        alert( error )
      }
        

  }

  }

  const onError = (e) => {
    console.log("onError: ", e)
  }

  // Password
  const [showPassword, setShowPassword] = useState(false);

  const passwordVisibilityChange = () => {
    setShowPassword(!showPassword);
  }



  return (
  <>
    <div className="mt-5 mb-1  " >


   


      <div className="row">

        <h1 className="mb-5 d-flex justify-content-center">Inicio de Sesión</h1>

        
      </div> 
    
      <div className="mt-5 d-flex justify-content-center">
        <Form onSubmit={
          handleSubmit(onSubmit, onError)
        }
          className="m-auto">
          <div className="row">
            {/* <div className="d-flex justify-content-between align-items-center">
              <label className="label-style">Correo</label>
              <div className="d-flex justify-content-between align-items-center">
                <p className="textAbogado me-2 mt-4">¿Eres administrador?</p>
                <input className="form-check-input ml-2 check" type="checkbox" id="soyAbogado" {...register("validation",)} />
              </div>
            </div> */}
            {/* <label className="label-style"></label> */}
            <label className="label-style">Usuario</label>
            <input className="input-style" {...register("mail", {
              required: {
                value: true,
                message: "El correo es necesario."
              }
            })}></input>

            {errors?.mail?.type === "required" && <p className="error-msg">
              {
                errors.mail.message
              }</p>
            }
          </div>



          <div className="row mt-2">
            <div className="col-sm-12 p-0" >
              <div className="wrapper w-100">
                <label className="label-style">Contraseña</label>
                <input type={showPassword ? "text" : "password"} className="input-style password input" {...register("password", {
                  required: {
                    value: true,
                    message: "La contraseña es necesaria."
                  }
                })}>

                </input>
                {/* </div>

                <div className="col-sm-1 mt-5"> */}

              

                <button type="button" className="btn  btn-eye icon" style={{backgroundColor: "transparent", border: "none", color:'black' }}
                  onClick={passwordVisibilityChange}
                >
                  {
                    showPassword ? <AiFillEyeInvisible /> : <AiFillEye />
                  } </button>
                {errors?.password?.type === "required" && <p className="error-msg">
                  {
                    errors.password.message
                  }</p>
                }
              </div>

            </div>
            
          </div>




          <div className="row mt-4">
            <div className="col">
              <a className="crt-account" onClick={onCrearCuenta} >Crear cuenta</a>
            </div>
            <div className="col">
              <button className="btn-aux btn btn-primary ">Iniciar</button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  </> )
}
